import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { UserRole } from '../types/auth';
import { Body1, Button } from '@fluentui/react-components';
import { HomeRegular } from '@fluentui/react-icons';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
  fallback?: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  allowedRoles, 
  fallback 
}) => {
  const { user, loading, hasRole } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Body1>Loading...</Body1>
      </div>
    );
  }

  if (!user) {
    // Automatically redirect to login page
    return <Navigate to="/login" replace />;
  }

  if (!hasRole(allowedRoles)) {
    return fallback ? (
      <>{fallback}</>
    ) : (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        gap: '16px'
      }}>
        <Body1>You don't have permission to access this page.</Body1>
        <Body1>Your role: {user.role}</Body1>
        <Body1>Required roles: {allowedRoles.join(', ')}</Body1>
        <Button 
          appearance="primary" 
          icon={<HomeRegular />}
          onClick={() => navigate('/home')}
        >
          Go to Home
        </Button>
      </div>
    );
  }

  return <>{children}</>;
}; 